import { Component, AfterViewInit, inject } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'recording-response',
    templateUrl: './recording-response.component.html',
    standalone: false
})
export class RecordingResponseComponent implements AfterViewInit {
    private translate = inject(TranslateService);

    ngAfterViewInit() {
        document.title = this.translate.instant('interviews.Record Response Title');
        (document.querySelector('.mock-interviews-header h1') as HTMLElement)?.focus();
    }
}
